import React, { useRef } from "react";
import useInView from "../../hooks/useInView";
import "./ArtistImages.css";
import portrait1 from "../../assets/portraits/D8470_PNG.png";
import portrait2 from "../../assets/portraits/D8470A_PNG.png";

const ArtistImages = () => {
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  // Check if each image is in view
  const leftVisible = useInView(leftRef);
  const rightVisible = useInView(rightRef);

  return (
    <div className="artist-images-container">
      <img
        ref={leftRef}
        src={portrait1}
        alt="Artist Portrait 1"
        className={`portrait left ${leftVisible ? "fade-in-left" : ""}`}
      />
      <img
        ref={rightRef}
        src={portrait2}
        alt="Artist Portrait 2"
        className={`portrait right ${rightVisible ? "fade-in-right" : ""}`}
      />
    </div>
  );
};

export default ArtistImages;
